import * as R from 'ramda'

export const billing = {
	el: '#billing-vue',

	data: {
		state: ""
	},

	computed: {

		states() {
			return R.pipe(
				R.pathOr([], ['store', 'mexico_states_and_mun']),
				R.keys
			)(this)
		},

		municipalities() {
			return R.pipe(
				R.pathOr([], ['store', 'mexico_states_and_mun']),
				R.pathOr([], [this.state]),
				R.map(R.prop('NOM_MUN'))
			)(this)
		},

        // countries(){
		// 	return R.pipe(
		// 		R.pathOr([], ['store', 'countries']),
		// 	)(this)
        // }
	},

	methods: {
	},

};



// WEBPACK FOOTER //
// ./resources/assets/js/vue/main/billing.js